import Class from './ClassNames';

function makePerformanceListItemHtml(data) {
  const { actionUrl, performanceTitle, displayTime, performanceStatusMessage } = data;

  return `
    <li class="${Class.BASE}__day-event-list-item">
      <a href="${actionUrl}" class="${Class.BASE}__event btn btn-primary">
        <span class="${Class.BASE}__event-name">${performanceTitle}</span>
        <span class="${Class.BASE}__event-time">
          <span class="sr-only">, </span>${displayTime}</span>
        </span>
        ${performanceStatusMessage ? `
          <span class="${Class.BASE}__event-status">
            <span class="sr-only">, </span>${performanceStatusMessage}
          </span>
        ` : ''
        }
      </a>
    </li>
  `;
}

function makePerformanceListHtml(perfs) {
  const listItems = perfs.map(perf => makePerformanceListItemHtml(perf));

  return `
    <ul class="${Class.BASE}__day-event-list">
      ${listItems.join('')}
    </ul>
  `;
}

export {
  makePerformanceListItemHtml,
  makePerformanceListHtml,
};



// WEBPACK FOOTER //
// ./V7/events/listing/calendarView/html/Performance.js